export default __webpack_public_path__ + "static/media/ilustracao-mulher-trofeu.44ba2d5a.svg";